<template>
<div class="DeviceListsGas">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>        
        <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <el-input class="common" placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable>
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-button
            class="common"
            type="primary"
            size="medium"
            @click="serachData"
            icon="el-icon-search">搜索</el-button>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button> -->
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
          <!-- <button class="delSome" @click="changeRightCons" v-show="!isMobile">
            <i class="imgShow" :class="changeStatus?'active':''"><img src="../../assets/img/deviceGas/open.png" alt=""></i>
            <span>{{changeStatus?'收起统计':'展开统计'}}</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <!-- <ul class="clearfix cardList">
              <li v-for="(dataInfo,index) in dataList" :key="index">
                <card :showFields="fields" :info="dataInfo" @clickEven="clickEven"></card>
              </li>
            </ul> -->
            <ul class="clearfix device-cardList">
              <li :class="['device-card', item.isOnline == '离线' ? 'out-card' : (item.isAlarm == '报警中' && item.removal != '0') ? 'alarm-card' : '']" v-for="(item,index) in dataList" :key="index">
                <div class="chart-item">
                  <h6>
                    <span class="title ellipsis-1">{{item.name}}</span>
                    <div class="title-right">
                      <!-- 电量 -->
                      <span v-if="item.batteryLevel">{{ item.batteryLevel < 0 ? 0 : item.batteryLevel > 100 ? 100 : item.batteryLevel }}%</span>
                      <span class="electric" v-if="item.batteryLevel">
                        <i :class="item.batteryLevel <= 20 ? 'red':''" :style="{width: (item.batteryLevel < 0 ? 0 : item.batteryLevel > 100 ? 100 : item.batteryLevel) + '%'}"></i>
                        <img v-if="item.isOnline == '离线' || item.batteryLevel == false" src="../../assets/img/devicetype/electric-gray.png" alt="" />
                        <img v-else-if="item.batteryLevel <= 20" src="../../assets/img/devicetype/electric-red.png" alt="" />
                        <img v-else src="../../assets/img/devicetype/electric.png" alt="" />
                      </span>
                      <!-- 信号 -->
                      <!-- <span class="sign-num" v-if="item.isOnline != '离线'">{{item.csq}}%</span>
                      <img class="sign" src="../../assets/img/bigScreen/sign-0.png" alt="" v-if="item.isOnline == '离线'">
                      <img class="sign" :src="signImg(item.sign)" alt="" v-else> -->
                      <!-- 详情图标 -->
                      <span class="edit" @click="clickEven(item)">
                        <i class="el-icon-edit-outline"></i>
                      </span>
                    </div>
                  </h6>
                  <div class="chart">
                    <div class="top-title" ref="titleC" :style="{ background: titleColor(item, index) }">
                      <img v-if="item.removal!='0' &&  item.isAlarm!='报警中'" src="../../assets/img/devicetype/door-white.png" alt="">
                      <img v-if="item.removal!='0' &&  item.isAlarm=='报警中'" src="../../assets/img/devicetype/door-On.png" alt="">
                      <span>{{item.removal=="0" ? "未启用" : item.isAlarm == "报警中"? "报警中..." : "监控中..."}}</span>
                    </div>
                    <img class="img-main" src="../../assets/img/devicetype/door-0.png" alt="" v-if="item.removal=='0' || item.isOnline == '离线'">
                    <img class="img-main2" src="../../assets/img/devicetype/door-2.png" alt="" v-else-if="item.isAlarm == '报警中'">
                    <img class="img-main1" src="../../assets/img/devicetype/door-1.png" alt="" v-else>

                    <img class="img-aside" src="../../assets/img/devicetype/door-aside.png" alt="">
                    <div class="switch-box">
                      <span  class="set" @click="handleSet(0, index, item)">撤防</span>
                      <span  class="set" @click="handleSet(1, index, item)">布防</span>
                      <span
                        class="active"
                        :style="{ background: item.removal == '0' ? '#EE211C' : '#4CC790', left: item.removal == '0' ? '0' : '48px'}"
                        :ref="`active${index}`">
                        {{item.removal == "0" ? "撤防" : "布防"}}
                      </span>
                    </div>
                  </div>
                  
                  <div class="device-params">
                    <div>
                      <p class="params-t">位置</p>
                      <p class="text">{{item.installLocation || '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">区域</p>
                      <p class='ellipsis-2'>{{item.quyu || '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">状态</p>
                      <p class="time-t">{{item.isOnline || '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">信号</p>
                      <p>{{item.rsrp || '--'}}</p>
                    </div>
                  </div>
                  <div class="item-bottom">模组号： {{item.imei}}</div>
                </div>
              </li>
            </ul>            
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizes"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>
        <div class="maskingRight" v-if="changeStatus">
          <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
            <div class="messContainer">
              <div class="cons">
                <device-right-cons :typeId="9" @closeRightCons="closeRightCons"></device-right-cons>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
       <el-breadcrumb separator=">">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/doorMagnetic' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/deviceGas' }">
            <span @click="jumpDev">设备信息</span>
          </el-breadcrumb-item> -->
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb> 
    </div>
    
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei" type="doorsensor" :isMobile="isMobile"></component>
    </div>
  </div>
  <el-dialog title="下发设置" :visible.sync="isShowSet" width="540px">
    <div class="dialog-box">
      <ul class="edit-dialog">
        <li>
          <span class="title">布防撤防</span>
          <div class="switch-box">
            <span  class="set" @click="handleRadarSet(0)">撤防</span>
            <span  class="set" @click="handleRadarSet(1)">布防</span>
            <span
              class="active"
              ref="activeNone"
              :style="{ background: setParams.absentAlarmEnable ? '#4CC790' : '#EE211C', left: setParams.absentAlarmEnable ? '48px' : '0'}"
              >
              {{setParams.absentAlarmEnable ? "布防" : "撤防"}}
            </span>
          </div>
        </li>
        <li>
          <span class="title">持续时间</span>
          <el-input-number v-model="setParams.days" controls-position="right" ></el-input-number>
          <span> 小时</span>
        </li>
        <li v-if="setParams.updateTime">
          <span class="title">上次下发时间</span>
          <span>{{setParams.updateTime}}</span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSetSave">保 存</el-button>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/components/common/Card'
export default {
  name:'DeviceGas',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons
  },
  computed: {
    titleColor () {
      return ({ removal, isAlarm }, i) => {
        // let temp = ['#C7C7C7', '#4CC790', '#EE211C']
        let color = removal == '0' ? '#C7C7C7' : isAlarm  == '报警中' ? '#EE211C' : '#4CC790'
        return color
      }
    },
    signImg() {
      return (n) => {
        return require(`../../assets/img/bigScreen/sign-${n}.png`)
      }
    }
  }, 
  data() {
    return {
      isShowSet: false,
      setParams: {
        absentAlarmEnable: 0,
        days: 0,
        updateTime: '--'
      },
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
          value: '1',
          label: '在线'
        }, {
          value: '0',
          label: '离线'
        }
      ],
      component: '',
      tabs: [{
        name: '基本信息',
        code: 'BasicInfo'
      }, {
        name: '设备数据',
        code: 'DeviceDatas'
      }, 
      // {
      //   name: '下发命令',
      //   code: 'IssueCommand'
      // },
      {
        name: '报警记录',
        code: 'AlarmRecord'
      }, {
        name: '故障记录',
        code: 'FaultRecord'
      }, {
        name: '安装记录',
        code: 'InstallRecord'
      }],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12,22,32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields:[],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      isMobile: false, // 是否是终端设备
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      }
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    this.getDeviceType()
  },
  methods: {
    handleClickSet ({ deviceId, removal, days, updateTime }) {
      this.setParams = {
        absentAlarmEnable: removal == '1' ? 1 : 0,
        days,
        updateTime
      }
      this.deviceId = deviceId
      this.isShowSet = true
    },
    handleRadarSet (type) {
      let temp = [
        { text: '撤防', color: '#EE211C', left: '0px', deviceRemoval: false },
        { text: '布防', color: '#4CC790', left: '48px', deviceRemoval: true }
      ]

      this.setParams.absentAlarmEnable = type
      let dom = this.$refs.activeNone
      dom.style = `left: ${temp[type].left};background: ${temp[type].color}`
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域 - 不用
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          // this.treeData.push({
          //   children: [],
          //   id: 'mobile',
          //   label: "终端出库设备",
          //   parentId: 0,
          //   serial: 51,
          //   tenantId: null,
          //   terminalFlag: null,
          //   value: 0
          // })
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.isMobile = item.id == 'mobile'
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data?res.data.data:[]
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow=false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId?this.currentTreeId:0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }

      let url = this.params.orgId == -1 ? '/front/device/doorsensor/queryOutbound' : '/front/device/doorsensor/query'

      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow=true
            this.dataList = res.data ? res.data : []
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    /**
     * @Description 切换布防or撤防
     * @Author      YOYO     -             2021-10-21
     */
    handleSet (type, index, item) {
      let { deviceId, typeId } = item
      if (typeId == 391) {
        return this.handleClickSet(item)
      }
      let temp = [
        { text: '撤防', color: '#EE211C', left: '0px', removal: '0' },
        { text: '布防', color: '#4CC790', left: '48px', removal: '1' }
      ]
      // let dom = this.$refs[`active${index}`]

      this.request.get('/front/device/doorsensor/removal', { deviceId, removal: type }).then(res => {

        if (res.code == 200) {
          // dom[0].style = `left: ${temp[type].left};background: ${temp[type].color}`
          // this.dataList[index].removal = temp[type].removal
          this.initData()
          this.$message({ type: 'success', message: '操作成功！' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      })
    },
    handleSetSave () {
      let { deviceId } = this
      let { absentAlarmEnable, days } = this.setParams
      this.request.get('/front/device/doorsensor/removal', { deviceId, removal: absentAlarmEnable, days }).then(res => {

        if (res.code == 200) {
          this.initData()
          this.$message({ type: 'success', message: '操作成功！' })
          this.isShowSet = false
          this.setParams = {
            absentAlarmEnable: 0,
            days: 0,
            updateTime: '--'
          }
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      })
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 205) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage =1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons(){
      if(!this.changeStatus){
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        }, 440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },    
  }
};
</script>

<style lang="scss" scoped>
.DeviceListsGas {
  position: relative;
  .devcieContainer{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    h4 {
      padding-bottom: 10px;
    }
    .container {
      padding-left: 260px;
    }
    .query {
      padding-bottom: 10px;
      .queryCons{
        width: 100%;
        overflow: hidden;
        .common{
          float: left;
          margin-bottom: 5px;
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover {
            background: #0774e0;
          }
        }
        .delSome{
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;
          // &:hover{
          //   background: #0774e0;
          // }
          // .imgShow{
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin:10px 6px 0 0;
          //   img{
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }
          //   &.active{
          //     transform: rotate(180deg);
          //   }
          // }
          // span{
          //   float: left;
          //   font-size: 14px;
          //   line-height: 36px;
          // }
        }
      }
    }
    .listsContainer {
      overflow: hidden;
      position: relative;
      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f3f3f3;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .device-cardList {
          height: 100%;
          width: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 14px;
          // display: flex;
          // flex-wrap: wrap;
          // justify-content: space-between;
          .device-card {
            display: inline-block;
            border: 1px solid #E1E1E1;
            background: #fff;
            width: 342px;
            height: 290px;
            padding: 5px 10px;
            margin-top: 20px;
            margin-left: 20px;
            color: #000;
            .chart-item {
              overflow: hidden;
              height: 290px;
              position: relative;
              h6 {
                overflow: hidden;
                height: 28px;
                line-height: 28px;
                border-bottom: 1px solid #E1E1E1;
                .title {
                  font-size: 16px;
                  display: inline-block;
                  vertical-align: top;
                  margin-left: 5px;
                  width: 240px;
                }
                .title-right {
                  font-size: 12px;
                  float: right;
                  color: #178FFD;
                  margin-top: -2px;
                  position: relative;
                  z-index: 2;
                  >span {
                    vertical-align: middle;
                  }

                  .electric {
                    position: relative;
                    top: -2px;
                    display: inline-block;
                    width: 20px;
                    margin-left: 4px;
                    i {
                      position: absolute;
                      top: 11px;
                      left: 1px;
                      height: 10px;
                      background-color: #178FFD;
                      &.red {
                        background-color: #F24F4B;
                      }
                    }
                  }
                  .edit {
                    font-size: 20px;
                    margin-left: 8px;
                    cursor: pointer;
                  }
                }
              }
              .chart {
                position: relative;
                display: inline-block;
                width: 180px;
                height: 100%;
                vertical-align: top;
                .top-title {
                  color: #fff;
                  font-size: 13px;
                  background: #C7C7C7;
                  width: 90px;
                  height: 25px;
                  text-align: center;
                  line-height: 25px;
                  border-radius: 4px;
                  position: absolute;
                  top: 10px;
                  left: 22px;
                  &.gray {
                    background: #C7C7C7;
                  }
                  &.red {
                    background: #EE211C;
                  }
                  &.green {
                    background: #4CC790;
                  }
                  img {
                    height: 16px;
                    vertical-align: middle;
                    margin-right: 5px;
                  }
                }
                .img-main {
                  width: 100px;
                  position: absolute;
                  top: 47px;
                  left: 20px; 
                }
                .img-main1 {
                  width: 60px;
                  position: absolute;
                  top: 64px;
                  left: 40px;
                }
                .img-main2 {
                  width: 130px;
                  position: absolute;
                  top: 55px;
                  left: 8px;
                }
                .img-aside {
                  position: absolute;
                  top: 47px;
                  left: 145px;                  
                  width: 28px;
                }
                .switch-box {
                  position: absolute;
                  bottom: 72px;
                  left: 20px;
                  border-radius: 25px;
                  overflow: hidden;
                  line-height: 20px;
                  font-size: 12px;
                  background: #F3F3F3;
                  color: #bbb;
                  .set {
                    cursor: pointer;

                  }
                  span {
                    display: inline-block;
                    width: 50px;
                    text-align: center;
                  }
                  .active {
                    width: 52px;
                    border-radius: 25px;
                    position: absolute;
                    top: 0px;
                    left:0px;
                    color: #fff;
                    background: #EE211C;
                    transition: 0.3s;
                  }
                }
              }
              .device-params {
                display: inline-block;
                width: 150px;
                margin-top: 18px;
                margin-left: 10px;
                >div {
                  margin-bottom: 10px;
                  font-size: 12px;
                  .params-t {
                    display: inline-block;
                    color: #178FFD;
                    border: 1px solid #178FFD;
                    padding: 0px 12px;
                    line-height: 22px;
                    font-size: 13px;
                    font-weight: bold;
                    margin-bottom: 3px;
                  }
                  .text {
                    max-height: 34px;
                    overflow: hidden;
                  }
                }
              }
              .item-bottom {
                border-top: 1px solid #E1E1E1;
                position: absolute;
                bottom: 0px;
                right: 0px;
                width: 100%;
                height: 22px;
                line-height: 26px;
                font-size: 12px;
                font-weight: 400;
                color: #B4B4B4;
                text-align: right;
                padding-right: 10px;
              }
            }
          }
          .out-card {
            
            .chart-item {
              h6 {
                .title-right {
                  color: #B8BABC;
                  .electric {
                    i {
                      background-color: #B8BABC;
                      &.red {
                        background-color: #B8BABC;
                      }
                    }
                  }
                }
              }
              .chart {
                .top-title {
                  background-color: #C7C7C7!important;
                }
                .switch-box {
                  .active {
                    background-color: #C7C7C7!important;
                  }
                }
              }
              .device-params {
                color: #B8BABC;
                >div {
                  .params-t {
                    color: #B8BABC;
                    border-color: #B8BABC;
                  }
                }
              }
            }
          }
          .alarm-card {
            .chart-item {
              .chart {
                .top-title {
                  background-color: red!important;
                }
                .switch-box {
                  .active {
                    background-color: red!important;
                  }
                }
              }
              .device-params {
                color: red;
                >div {
                  .params-t {
                    color: red;
                    border-color: red;
                  }
                }
              }
            }
          }
        }
        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }
        &.active{
          width: 100%;
          .cardList{
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            &>li{
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }
    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }  
  .mainContent{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    .navShow {
      overflow: hidden;
      margin-bottom: 10px;
      border-bottom: 1px solid #f2f2f2;
    }
  }
  .dialog-box {
    .title-set-alarm {
      font-size: 14px;
      color: #409EFF;
      margin-top: 20px;
    }
    .edit-dialog {
      margin-bottom: 40px;
      margin-left: 15px;
      li {
        margin-top: 20px;
        .title {
          font-size: 14px;
          color: #333;
          display: inline-block;
          width: 100px;
        }
        .el-input {
          width: 180px;
          line-height: 40px;
          height: 40px;
        }
        .el-input-number__decrease, .el-input-number__increase {
          bottom: 4;
        }
        .el-input-number {
          &.is-controls-right .el-input-number__decrease, &.is-controls-right .el-input-number__increase {
            line-height: 15px;
          }
          &.is-controls-right .el-input-number__decrease {
            bottom: 4;
          }
        }
        .switch-box {
          display:inline-block;
          position: relative;
          top: 5px;
          // right: 30px;
          border-radius: 25px;
          overflow: hidden;
          line-height: 20px;
          font-size: 12px;
          background: #F3F3F3;
          color: #bbb;
          .set {
            cursor: pointer;

          }
          span {
            display: inline-block;
            width: 50px;
            text-align: center;
          }
          .active {
            width: 52px;
            border-radius: 25px;
            position: absolute;
            top: 0px;
            left:0px;
            color: #fff;
            background: #EE211C;
            transition: 0.3s;
          }
        }
      }
      .tip {
        color: red;
        margin-top: 20px;
        font-size: 12px;
      }
    }
    .dialog-footer {
      text-align: right;
    }
  }
  @keyframes slid-open {
      0%{
          transform: translateX(100%);
          opacity: 0;
      }
      100%{
          transform: translateX(0);
      }
  }
  @keyframes slid-out {
    0%{
      width: 600px;
      transform: translateX(0)
    }
    100%{
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.DeviceListsGas {
  .devcieContainer{
    .query {
      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 110px;
        margin-right: 10px;

        .el-input {
          width: 110px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }
    }
    .el-loading-mask{
      background-color: unset;
    }
    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 15px 20px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 20px;
        z-index: 10;
        // left: 30px;
        padding-left: 10px;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: 100%;
        border: 1px solid #ebeef5;
        padding: 40px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .mainContent{
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      color: #7A7D81;
      font-size: 16px;
      font-weight: 500;
    }
    .el-breadcrumb__separator{
      font-size: 16px;
      color: #7A7D81;
      margin: 0 5px;
      font-weight: 500;
    }
    .el-breadcrumb__inner{
      font-size: 16px;
      color: #7A7D81 !important;
      font-weight: 500 !important;
    }
  }
}
</style>
